import React, { Fragment, useState, useReducer, useMemo } from "react";
import { Tab, Nav, Collapse } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

// import SideBar from "./SideBar";
import NavHeader2 from "./NavHeader2";
import Header from "./Header";
import ChatBox from "../ChatBox";

//Menus
import { MenuList2 } from "./Menus2";

//Images
import icon1 from "./../../../images/browser/icon1.png";
import icon2 from "./../../../images/browser/icon2.png";

import ShareProfitCanvas from "./FixedData/ShareProfitCanvas";
import DailySalesCanvas from "./FixedData/DailySalesCanvas";
//Icons
import { SVGICON } from "../../constant/theme";
import LogoutMini from "./LogoutMini";

const browserList = [
  { image: icon1, title: "Chrome", color: "warning", percent: "90%" },
  { image: icon2, title: "Firefox", color: "success", percent: "80%" },
  { image: icon1, title: "Chrome", color: "danger", percent: "70%" },
];

const adminGroup = process.env.REACT_APP_ADMIN_GROUP;

const sidebarMenu = [
  {
    mainicon: SVGICON.MetroMap, 
    menuKey: "Metro Map",
    to: "/",
  },
  {
    mainicon: SVGICON.HeartbeatSvg,
    menuKey: "HeartBeat Status",
    to: "/HeartbeatDashboard",
  },
  {
    mainicon: SVGICON.DqSvg,
    menuKey: "Data Quality Dashboard",
    to: "/dq",
  },
  {
    mainicon: SVGICON.E1,
    menuKey: "E1 Dashboard",
    to: "/e1_dq_metrics",
  },
  {
    mainicon: SVGICON.HomeIcon,
    menuKey: "Right To Be Forgotten",
    to: "/rtbf_approvals",
  },
  {
    mainicon: SVGICON.TableIcon,
    menuKey: "Data Classification",
    to: "/classification_approvals",
  },
  {
    mainicon: SVGICON.DbtSvg,
    menuKey: "DBT Jobs Dashboard",
    to: "/dbt_dashboard",
  },
  // {
  //   mainicon: SVGICON.PrefectSvg,
  //   menuKey: "Prefect Jobs Dashboard",
  //   to: "/prefect_dashboard",
  // },
  {
    mainicon: SVGICON.JDESvg,
    menuKey: "JDE Jobs Dashboard",
    to: "/jde_dashboard",
  },
  {
    mainicon: SVGICON.AwsGlueSvg,
    menuKey: "AWS Glue Jobs Dashboard",
    to: "/aws_glue_dashboard",
  },
  {
    mainicon: SVGICON.QlikSvg,
    menuKey: "Qlik Dashboard",
    to: "/qlik_dashboard",
  },
  { mainicon: SVGICON.JiraSvg, menuKey: "Projects KPI", to: "/projects_kpi" },
  {
    mainicon: SVGICON.AirflowSvg,
    menuKey: "Airflow Jobs Dashboard",
    to: "/aws_airflow_dashboard",
  },
  {
    mainicon: SVGICON.SnowflakeSvg,
    menuKey: "Snowflake Jobs Dashboard",
    to: "/snowflake_dashboard",
  },
  {
    mainicon: SVGICON.PowerBiSvg,
    menuKey: "Power BI Dashboard",
    to: "/pbi",
  },
  {
    mainicon: SVGICON.BuildProSvg,
    menuKey: "PO Metro Map",
    to: "/po-metro-map",
  },
  // { mainicon: SVGICON.LockScreen, menuKey: "Data Lineage", to: '/lineage' },
  // { mainicon: SVGICON.PageIcon, menuKey: "Data Lineage", to: '/dashboard', },
  // {mainicon: SVGICON.SettingIcon, menuKey:"Cms"},
  // {mainicon: SVGICON.AppsIcon, menuKey:"Apps"},
  // { mainicon: SVGICON.BootstrapIcon, menuKey: "Bootstrap" },
  // {mainicon: SVGICON.FormIcon, menuKey:"Form"},
  // {mainicon: SVGICON.TableIcon, menuKey:"Table"},
  // {mainicon: SVGICON.PageIcon, menuKey:"Page"},
  // {mainicon: SVGICON.ShoppingIocn, menuKey:"Shopping"},
];

const sidebarMenuBase = [
  {
    mainicon: SVGICON.MetroMap, 
    menuKey: "Metro Map",
    to: "/",
  },
  {
    mainicon: SVGICON.HeartbeatSvg,
    menuKey: "HeartBeat Status",
    to: "/HeartbeatDashboard",
  },
  {
    mainicon: SVGICON.DbtSvg,
    menuKey: "DBT Jobs Dashboard",
    to: "/dbt_dashboard",
  },
  {
    mainicon: SVGICON.DqSvg,
    menuKey: "Data Quality Dashboard",
    to: "/dq",
  },
  {
    mainicon: SVGICON.E1,
    menuKey: "E1 Dashboard",
    to: "/e1_dq_metrics",
  },
  // {
  //   mainicon: SVGICON.PrefectSvg,
  //   menuKey: "Prefect Jobs Dashboard",
  //   to: "/prefect_dashboard",
  // },
  {
    mainicon: SVGICON.JDESvg,
    menuKey: "JDE Jobs Dashboard",
    to: "/jde_dashboard",
  },
  {
    mainicon: SVGICON.AwsGlueSvg,
    menuKey: "AWS Glue Jobs Dashboard",
    to: "/aws_glue_dashboard",
  },
  {
    mainicon: SVGICON.QlikSvg,
    menuKey: "Qlik Dashboard",
    to: "/qlik_dashboard",
  },
  {
    mainicon: SVGICON.AirflowSvg,
    menuKey: "Airflow Jobs Dashboard",
    to: "/aws_airflow_dashboard",
  },
  {
    mainicon: SVGICON.BuildProSvg,
    menuKey: "PO Metro Map",
    to: "/po-metro-map",
  },
  {
    mainicon: SVGICON.PowerBiSvg,
    menuKey: "Power BI Dashboard",
    to: "/pbi",
  },
];

const initialState = false;
const reducer = (state, action) => {
  switch (action.type) {
    case "collpase0":
      return { ...state, collpase0: !state.collpase0 };
    case "collpase1":
      return { ...state, collpase1: !state.collpase1 };
    case "collpase2":
      return { ...state, collpase2: !state.collpase2 };
    case "collpase3":
      return { ...state, collpase3: !state.collpase3 };
    default:
      return state;
  }
};

const updateReducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const menuInitial = {
  active: "",
  activeSubmenu: "",
};

const Deflayout = ({ title, onClick: ClickToAddEvent }) => {
  const { accounts } = useMsal();
  const isAuthenticated = accounts.length > 0;
  console.log("isAuthenticated", isAuthenticated);
  

  const username = useMemo(() => accounts[0].name ?? "Unknown", [accounts]);
  let userEmail = useMemo(
    () => accounts[0].username ?? "Unknown",
    [accounts]
  );

  
  let sidebarMenuToUse;
  if (adminGroup.includes(userEmail)) {
    sidebarMenuToUse = sidebarMenu;
  } else {
    sidebarMenuToUse = sidebarMenuBase;
  }

  const [toggle, setToggle] = useState("");
  const onClick = (name) => setToggle(toggle === name ? "" : name);

  const [activeMenu, setActiveMenu] = useState(0);
  const [state, dispatch] = useReducer(reducer, initialState);

  const [menustate, setMenustate] = useReducer(updateReducer, menuInitial);
  const handleMenuActive = (status) => {
    setMenustate({ active: status });
    if (menustate.active === status) {
      setMenustate({ active: "" });
    }
  };
  const handleSubmenuActive = (status) => {
    setMenustate({ activeSubmenu: status });
    if (menustate.activeSubmenu === status) {
      setMenustate({ activeSubmenu: "" });
    }
  };

  const [openSidebar, setOpenSidebar] = useState(false);
  const [closeSidebar, setCloseSidebar] = useState(0);
  function handleMenuOpen(ind) {
    if (ind === closeSidebar) {
      setOpenSidebar(!openSidebar);
    }
  }

  return (
    <Fragment>
      <NavHeader2 openSidebar={openSidebar} />
      <ChatBox onClick={() => onClick("chatbox")} toggle={toggle} />
      <Tab.Container defaultActiveKey={"Dashboard"}>
        <Header
          onNote={() => onClick("chatbox")}
          onNotification={() => onClick("notification")}
          onProfile={() => onClick("profile")}
          toggle={toggle}
          title={title}
          onBox={() => onClick("box")}
          onClick={() => ClickToAddEvent()}
        />
        {/* <SideBar /> */}
        <div className="deznav">
          <div className="deznav-scroll">
            <Nav as="ul" className="nav menu-tabs">
              {sidebarMenuToUse.map((item, index) => (
                <Nav.Item
                  as="li"
                  key={index}
                  onClick={() => {
                    setOpenSidebar(false);
                    handleMenuOpen(index);
                    setCloseSidebar(index);
                  }}
                >
                  <Nav.Link
                    className="ai-icon"
                    eventKey={item.menuKey}
                    as={Link}
                    to={item.to}
                  >
                    {item.mainicon}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </div>
          <LogoutMini />
        </div>
      </Tab.Container>
    </Fragment>
  );
};

export default Deflayout;
